import { MatDialogRef } from '@angular/material';
import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-image-dialog',
    styleUrls: ['./modal-image-dialog.component.scss'],
    templateUrl: './modal-image-dialog.component.html',
})
export class ModalImageDialogComponent {
    public title: string;
    public firstMessage: string;
    public imgSrc: string;

    okButtonTextLabel = 'Aceptar';
    cancelButtonTextLabel = 'Cerrar';

    constructor(public dialogRef: MatDialogRef<ModalImageDialogComponent>) {}

    public set okButtonText(value: string)  {
      this.okButtonTextLabel = value;
    }

    public set cancelButtonText(value: string) {
      this.cancelButtonTextLabel = value;
    }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/modals/modal-image-dialog.component.ts